import { FillPreview, Tooltip } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../../ricos-context/index.js";
import { SWATCH, SWATCH_TOOLTIP } from "../../data-hooks.js";
const SingleColorSwatch = ({
  fill,
  selectedColor,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
  onFocus,
  setRef,
  index
}) => {
  const { t, portal } = useContext(RicosContext);
  const isTransparent = fill === "#00000000";
  const tooltipContent = isTransparent ? t("ColorPicker_RemoveColor_Tooltip") : fill;
  return /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      appendTo: portal,
      fixed: true,
      content: tooltipContent,
      dataHook: SWATCH_TOOLTIP,
      enterDelay: 1e3,
      size: "small",
      placement: "top",
      moveBy: { y: 10 },
      className
    },
    /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        id: index,
        selected: selectedColor?.toUpperCase() === fill.toUpperCase(),
        "aria-selected": selectedColor?.toUpperCase() === fill.toUpperCase(),
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick(fill);
        },
        onMouseEnter: () => onMouseEnter?.(fill),
        onMouseLeave,
        fill: isTransparent ? void 0 : fill,
        dataHook: SWATCH,
        onFocus,
        "aria-label": `${fill} color swatch`,
        tabIndex: -1,
        ref: setRef,
        role: "option"
      }
    )
  );
};
export {
  SingleColorSwatch
};
//# sourceMappingURL=single-color-swatch.js.map
